<template>
  <div class="backXmh" @click="GoHome"></div>
</template>
<style scoped lang="less">
.backXmh {
  width: 40px;
  height: 40px;
  background: url("../../../../assets/images/home/xmh_home.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  bottom: 170px;
  right: 12px;
  z-index: 97;
  font-size: @indexFontSize20;
  text-align: center;
}
</style>
<script>
export default {
  name:'backxmh',
  methods:{
    GoHome(){
      this.$emit('goHomeTap')
    }
  }
}
</script>
